import { render, staticRenderFns } from "./free.vue?vue&type=template&id=4a5bf21c"
import script from "./free.vue?vue&type=script&lang=js"
export * from "./free.vue?vue&type=script&lang=js"
import style0 from "./free.vue?vue&type=style&index=0&id=4a5bf21c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports